import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { hasAcademyAccess, homePath } from "@/lib/academyAccess";

// Fix T (2026-10-13): `academy` = permisos de academia que habilitan la pagina
// ([] = cualquiera). Si no le toca, cada usuario vuelve a SU pagina de inicio
// (antes siempre a /dashboard, que un usuario de la academia no puede ver).
export default function ProtectedRoute({ children, allowedRoles, academy }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background font-sans text-secondary-foreground" data-testid="auth-loading-state">
        Cargando...
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={homePath(user)} replace />;
  }

  if (academy && !hasAcademyAccess(user, academy)) {
    return <Navigate to={homePath(user)} replace />;
  }

  return children;
}
